// Mock data and functions for The Cleaning Crew website

export const mockServices = [
  {
    id: 1,
    title: "Domestic Cleaning",
    description: "Transform your home into a spotless sanctuary. Our professional team ensures every corner shines with meticulous attention to detail.",
    icon: "home",
    image: "https://images.unsplash.com/photo-1563453392212-326f5e854473"
  },
  {
    id: 2,
    title: "Commercial Cleaning",
    description: "Keep your business premises pristine and professional. We provide reliable cleaning solutions tailored to your commercial needs.",
    icon: "building",
    image: "https://images.unsplash.com/photo-1627905646269-7f034dcc5738"
  },
  {
    id: 3,
    title: "End of Tenancy Cleaning",
    description: "Moving out? Get your bond back with our comprehensive end of tenancy cleaning service. We meet all landlord requirements.",
    icon: "key",
    image: "https://images.unsplash.com/photo-1630699376059-b781970715b1"
  },
  {
    id: 4,
    title: "Builders Cleaning",
    description: "Post-construction cleanup done right. We remove dust, debris, and make your newly built or renovated space move-in ready.",
    icon: "hard-hat",
    image: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9"
  },
  {
    id: 5,
    title: "Deep Cleaning",
    description: "A thorough, top-to-bottom clean that reaches every corner. Perfect for seasonal refreshes or special occasions.",
    icon: "sparkles",
    image: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce"
  },
  {
    id: 6,
    title: "Window Cleaning",
    description: "Crystal clear windows that let the light shine through. Internal cleaning included, external available upon request.",
    icon: "square",
    image: "https://images.unsplash.com/photo-1482449609509-eae2a7ea42b7"
  },
  {
    id: 7,
    title: "Oven & Kitchen Deep Cleaning",
    description: "Restore your kitchen to showroom condition. Our specialist cleaning tackles grease, grime, and stubborn stains.",
    icon: "chef-hat",
    image: "https://images.unsplash.com/photo-1623114112815-74a4b9fe505d"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Whakatane",
    rating: 5,
    comment: "The Cleaning Crew did an outstanding job on our end of tenancy clean. We got our full bond back! Highly professional and thorough.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "David Thompson",
    location: "Ohope",
    rating: 5,
    comment: "I use them for my office cleaning every week. Always reliable, always spotless. Best cleaning service in the Bay of Plenty!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Emma Roberts",
    location: "Whakatane",
    rating: 5,
    comment: "They transformed my home! The deep clean was incredible - places I didn't even know needed cleaning are now sparkling. Worth every penny.",
    date: "3 weeks ago"
  }
];

export const mockWhyChooseUs = [
  {
    id: 1,
    title: "Professional & Reliable",
    description: "Trained experts who arrive on time, every time.",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "Attention to Detail",
    description: "We don't miss a spot - quality is our priority.",
    icon: "eye"
  },
  {
    id: 3,
    title: "Flexible Scheduling",
    description: "Services that fit your busy lifestyle.",
    icon: "calendar"
  },
  {
    id: 4,
    title: "Affordable Premium Service",
    description: "Luxury cleaning at competitive prices.",
    icon: "badge-dollar-sign"
  },
  {
    id: 5,
    title: "Trusted Local Business",
    description: "Proudly serving Whakatane and surrounding areas.",
    icon: "map-pin"
  }
];

// Mock form submission
export const submitQuoteForm = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  console.log("Quote form submitted:", formData);
  
  // Store in localStorage for demo purposes
  const existingQuotes = JSON.parse(localStorage.getItem('quoteRequests') || '[]');
  const newQuote = {
    ...formData,
    id: Date.now(),
    submittedAt: new Date().toISOString(),
    status: 'pending'
  };
  existingQuotes.push(newQuote);
  localStorage.setItem('quoteRequests', JSON.stringify(existingQuotes));
  
  return {
    success: true,
    message: "Thanks! We'll contact you shortly.",
    quoteId: newQuote.id
  };
};
